import * as React from 'react';

import * as styles from './Pagination.css';
import { Chips, Button } from '@cian/ui-kit';
import { IconActionArrowLeft16, IconActionArrowRight16 } from '@cian/ui-kit-design-tokens/icons';

interface IPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const Pagination: React.FC<IPaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageClick = (page: number) => {
    onPageChange(page);
  };

  const options = React.useMemo((): { value: number; label: string }[] => {
    const options = [];
    for (let i = 1; i <= totalPages; i++) {
      options.push({ value: i, label: i.toString() });
    }

    return options;
  }, [totalPages]);

  return (
    <div className={styles['container']}>
      <Button
        data-name="PaginationPrevious"
        theme="stroke_secondary"
        size="XS"
        beforeIcon={<IconActionArrowLeft16 />}
        onClick={handlePrevious}
        disabled={currentPage === 1}
      />
      <Chips selectType="oneOf" options={options} value={[currentPage]} inline onChipClick={handlePageClick} size="S" />
      <Button
        data-name="PaginationNext"
        theme="stroke_secondary"
        size="XS"
        beforeIcon={<IconActionArrowRight16 />}
        onClick={handleNext}
        disabled={currentPage === totalPages}
      />
    </div>
  );
};
